import { SelectOption } from '@globaleris/ui.library'
import {
  apiFetchComunicationDetails,
  apiFetchComunications,
  apiFetchMasterComunicationsOptions,
  apiPostComunication
} from '../../../../api/Argentia/endpoints/comunications/comunications.api'
import {
  ComunicationMailModel,
  ComunicationModel
} from '../../../../api/Argentia/model/comunication/comunications'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../../helpers/serviceResponseHelper'
import i18n from '../../../../i18n'
import { ActionIcons, DataTableActionConfiguration, DatePeriod } from '../../../../model'
import { ServiceResponse } from '../../../../model/serviceResponse'

export const fetchExternalsListItems = (datePeriod: DatePeriod) => {
  return fetchComunications(undefined, datePeriod?.start, datePeriod?.end)
}

export const fetchComunications = (
  subjectID?: number,
  startDate?: Date,
  endDate?: Date
): Promise<ServiceResponse<ComunicationModel[] | undefined>> => {
  return apiFetchComunications({ subjectID, startDate, endDate })
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchComunication = (
  id: number
): Promise<ServiceResponse<ComunicationMailModel[] | undefined>> => {
  return apiFetchComunicationDetails(id)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchMasterComunicationsOptions = (): Promise<
  ServiceResponse<SelectOption[] | undefined>
> => {
  return apiFetchMasterComunicationsOptions()
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createComunication = (
  subjectID: number,
  masterComunicationID: number,
  contractID: number
): Promise<ServiceResponse<ComunicationMailModel[] | undefined>> => {
  return apiPostComunication(subjectID, masterComunicationID, contractID)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#region Dispatches global actions

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getQuantityDisagreementAction(), getStateLoadingAction()]
}

const getQuantityDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.WARNING,
    tooltip: i18n.t('comunicationExternals:dataTable.tooltips.warning')
  }
}

const getStateLoadingAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.LOADING,
    tooltip: i18n.t('comunicationExternals:dataTable.tooltips.loading'),
    isLoading: true
  }
}

//#endregion
